
import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';

class forgotPasswordApi {
    static doForgotpassword(data) {
        let sendBody={
            email:data.email
        }
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(sendBody)
            }
            return fetch(BASE_URL + '/v1/users/password_reset_instructions', body).then(response => {
                // if(response.ok === true){
                //     window.location.href = '/resetpasswordnotice';
                // }
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){

        }
        
    }
}

export default forgotPasswordApi;